import {
  CREATE_PIA,
  CREATE_PIA_FAILED,
  CREATE_PIA_SUCCESS,
  FETCH_PIA,
  FETCH_PIA_COMPLETE,
} from "./types";

export const initialState = {
  addingPia: false,
  fetchingPia: false,
  piaActivities: {
    data: [],
    total: 0,
  },
  pia: {
    data: [],
  },
};

export const videoReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_PIA:
      return {
        ...state,
        fetchingPia: true,
      };
    case FETCH_PIA_COMPLETE:
      return {
        ...state,
        fetchingPia: false,
        piaActivities: {
          data: action?.payload?.data || [],
          total: action?.payload?.total || 0,
        },
      };
    case CREATE_PIA:
      return {
        ...state,
        addingPia: true,
      };
    case CREATE_PIA_FAILED:
      return {
        ...state,
        addingPia: false,
      };
    case CREATE_PIA_SUCCESS:
      return {
        ...state?.pia,
        data: [action?.pia, ...state?.pia?.data],
      };
    default:
      return state;
  }
};
